export default __webpack_public_path__ + "static/daniela-ec98f109a4a3ce4beadb90cbfa45df8b.png";